<template>
    <Content style="background:rgba(249,249,249,1);">
        <div class="bg"></div>
        <div class="main">
            <p style="text-align: left;line-height: 30px;">
                上海飞思海葬服务有限公司  位于上海市虹口区西宝兴路833号(上海市宝兴殡仪馆)2号楼2楼,交通便利，近年来坚持深化改革,改变单一经济,实行多业并举,逐步走出了经营田境,步入健康发展的执道。目前公司现有一批优秀专业技术人员和业务人员，主营：殡葬服务。热情欢迎各位光临指导，本公司以城信，双赢为理念，销售优质的产品，提供先进的技术并力创一流的服务。
            </p>
            <Row style="margin-top: 60px;">
                <Col span="12">
                    <Form ref="formValidate" :label-width="1" :rules="ruleValidate" :model="formValidate">
                        <FormItem prop="name">
                            <Input type="text" placeholder="请输入您的姓名" v-model="formValidate.name">
                                <Icon type="md-person" slot="prepend"/>
                            </Input>
                        </FormItem>
                        <FormItem prop="telephone">
                            <Input type="text" placeholder="请输入您的手机号码" v-model="formValidate.telephone">
                                <Icon type="md-phone-portrait" slot="prepend"/>
                            </Input>
                        </FormItem>
                        <FormItem prop="address">
                            <Input type="text" placeholder="请输入您的地址" v-model="formValidate.address">
                                <Icon type="md-pin" slot="prepend"/>
                            </Input>
                        </FormItem>
                        <FormItem prop="email">
                            <Input type="text" placeholder="请输入您的邮箱" v-model="formValidate.email">
                                <Icon type="md-mail" slot="prepend"/>
                            </Input>
                        </FormItem>
                        <FormItem prop="content">
                            <Input type="textarea" :autosize="{minRows: 7.5}" placeholder="请输入您的留言" v-model="formValidate.content">
                                <Icon type="md-list" slot="prepend"/>
                            </Input>
                        </FormItem>
                        <FormItem>
                            <Button type="primary" @click="save('formValidate')">提交</Button>
                            <Button style="margin-left: 8px" @click="reset('formValidate')">重填</Button>
                        </FormItem>
                    </Form>
                </Col>
                <Col span="10" offset="2">
                <div style="text-align: left;line-height: 34px;">
                    上海飞思海葬服务有限公司  <br/>
                    地　　址：上海市虹口区西宝兴路833号(上海市宝兴殡仪馆)2号楼2楼<br/>

                    联系电话：021-66600544&nbsp;&nbsp;&nbsp;&nbsp;021-962840<br/>

                </div>
                <img src="../assets/map.png" width="350px" height="350px" align="left" />
                </Col>
            </Row>
        </div>
    </Content>
</template>

<script>
    import api from '@/api/api'
    export default {
        name: "about",
        data(){
          return{
              formValidate: {
                  name: '',
                  telephone: '',
                  address: '',
                  email: '',
                  content: '',
              },
              ruleValidate: {
                  name: [
                      { required: true, message: '姓名不能为空', trigger: 'blur' }
                  ],
                  telephone: [
                      { required: true, message: '电话号码不能为空', trigger: 'blur' },
                      { min: 11, max: 11, message: '电话号码必须是11位数'}
                  ],
                  address: [
                      { required: false, message: '地址', trigger: 'blur' }
                  ],
                  email: [
                      { required: false, message: '邮箱', trigger: 'blur' }
                  ],
                  content: [
                      { required: true, message: '留言不能为空', trigger: 'blur' },
                  ],
              }
          }
        },
        methods:{
            save(form) {
                this.$refs[form].validate((valid) => {
                    if (valid) {
                        api.feedbackAdd(this.formValidate).then(res => {
                            this.$Message.success({
                                content: '提交成功',
                                duration: 3
                            });
                            this.$refs[form].resetFields();
                        }).catch(error => {
                            this.$Message.error('处理异常');
                        })

                    } else {
                        return;
                    }
                })
            },
            reset(form){
                this.$refs[form].resetFields();
            }
        }
    }
</script>

<style scoped>
    .layout {
        background: #f5f7f9;
        position: relative;
        overflow: hidden;
    }

    .bg {
        width: 100%;
        height: 280px;
        background: url("../assets/bannner4.png") no-repeat center;
        background-size: cover;
        -webkit-background-size: cover;
        -moz-background-size: cover;
    }

    .main {
        width: 60%;
        height: auto;
        margin: 58px auto;
        font-size:18px;
    }
    .main p {
        font-size:18px;
        font-family:MicrosoftYaHei;
        font-weight:400;
        color:rgba(51,51,51,1);
        text-indent:2em;
    }
</style>
